import { supabase } from "../supabaseClient";

async function getAllChangeRequests(leadId) {
	const { data, error, count } = await supabase
		.from("ChangeUnitRequests")
		.select(
			"* ,requestedUnitId(*,projectId(*),wingId(*),inventoryTypeId(*)), userId(*) ,allotmentPaymentId(* ,inventoryMergedId(*,projectId(*),unit1Id(*,wingId(*),inventoryTypeId(*)),unit2Id(*,wingId(*),inventoryTypeId(*))),unitId(* ,wingId(*), projectId(*),inventoryTypeId(*) ), leadId(* , personId(*) , cpId(*)))",
			{ count: "exact" }
		)
		.eq("allotmentPaymentId.leadId.leadId", leadId);
	if (data) return { data, count };
	else throw error;
}
async function updateChangeRequests(changeUnitRequestId, leadConfirmation) {
	console.log(changeUnitRequestId, leadConfirmation);
	const { data, error, count } = await supabase
		.from("ChangeUnitRequests")
		.update({ leadConfirmation: leadConfirmation })
		.eq("changeUnitRequestId", changeUnitRequestId);
	if (data) return { data, count };
	else throw error;
}

async function getAllCancelRequests(leadId) {
	const { data, error, count } = await supabase
		.from("CancelUnitRequests")
		.select(
			"* , userId(*) ,allotmentPaymentId(* ,inventoryMergedId(*,projectId(*),unit1Id(*,wingId(*),inventoryTypeId(*)),unit2Id(*,wingId(*),inventoryTypeId(*))),unitId(* ,wingId(*), projectId(*) ,inventoryTypeId(*)), leadId(* , personId(*) , cpId(*)))",
			{ count: "exact" }
		)
		.order("created_at", { ascending: false })
		.eq("allotmentPaymentId.leadId.leadId", leadId);
	if (data) return { data, count };
	else throw error;
}
// ??Update Cancel unit requests
async function updateCancelRequests(cancelUnitRequestId, leadConfirmation, requestPendingObj) {
	let updateObj = {
		status: leadConfirmation,
		leadConfirmation: leadConfirmation,
		last_updated_at: new Date().getTime(),
	};
	if (requestPendingObj) {
		updateObj = {
			leadConfirmation: leadConfirmation,
			last_updated_at: new Date().getTime(),
			requestPendingWithUserId: requestPendingObj.parentId,
			requestPendingWithRoleId: requestPendingObj.roleId,
		};
	}
	const { data, error, count } = await supabase.from("CancelUnitRequests").update(updateObj).eq("cancelUnitRequestId", cancelUnitRequestId);
	if (data) return { data, count };
	else throw error;
}

// Allotment payment status
async function updateAllotmentPaymentStatus(allotmentPaymentId, status) {
	const { data, error, count } = await supabase.from("AllotmentPayment").update({ status: status }).eq("allotmentPaymentId", allotmentPaymentId);
	if (data) return { data, count };
	else throw error;
}

// ??Update Lead Status
async function updateLeadAllStatus(leadId, status) {
	const { data, error } = await supabase.from("LeadStatus").update({ status: status, last_updated_at: Date.now() }).eq("leadId", leadId).single();
	if (data) return data;
	else throw error;
}
async function checkForCancelUnitRequest(unitId, inventoryMergedId) {
	var query;
	query = supabase
		.from("CancelUnitRequests")
		.select("*,allotmentPaymentId!left(*)", { count: "exact" })
		.order("last_updated_at", { ascending: false });
	if (inventoryMergedId === null || inventoryMergedId === undefined) {
		query = query.eq("allotmentPaymentId.unitId", unitId);
	} else {
		query = query.eq("allotmentPaymentId.inventoryMergedId", inventoryMergedId);
	}
	const { data, count, error } = await query;
	if (data) return { data, count };
}
//chancelAlotRequest
async function cancelAllotedUnit(userId, allotmentPaymentId, reason, status, requestedUnitId, requestPending, leadId) {
	const { data, error } = await supabase.from("CancelUnitRequests").insert([
		{
			userId: userId,
			allotmentPaymentId: allotmentPaymentId,
			reason: reason,
			status: status,
			requestPendingWithRoleId: requestPending.roleId,
			requestPendingWithUserId: requestPending.userId,
			leadConfirmation: "Accepted",
			leadId: leadId,
		},
	]);
	if (data) return data;
	else throw error;
}

async function addLeadLogs(obj) {
	const { data, error } = await supabase.from("LeadLogs").insert([{ ...obj }]);
	if (data) return data;
	else throw error;
}

// CRM last updated at after cancel unit
async function updateCRMLastUpdatedAt(allotmentPaymentId) {
	const { data, error, count } = await supabase.from("CRM").update({ last_updated_at: Date.now() }).eq("allotmentPaymentId", allotmentPaymentId);
	if (data) return { data, count };
	else throw error;
}

async function getAllotmentCancelledTransaction(allotmentPaymentId) {
	const { data, error } = await supabase
		.from("CancelUnitRequests")
		.select("*")
		.eq("allotmentPaymentId", allotmentPaymentId)
		.order("last_updated_at", { ascending: false });

	if (data) return data;
	else throw error;
}

async function getCancelledRequest(cancelUnitRequestId) {
	const { data, error } = await supabase
		.from("CancelUnitRequests")
		.select("*")
		.eq("cancelUnitRequestId", cancelUnitRequestId)

	if (data) return data;
	else throw error;
}

export {
	getAllChangeRequests,
	updateChangeRequests,
	getAllCancelRequests,
	updateCancelRequests,
	updateLeadAllStatus,
	updateAllotmentPaymentStatus,
	cancelAllotedUnit,
	checkForCancelUnitRequest,
	addLeadLogs,
	updateCRMLastUpdatedAt,
	getAllotmentCancelledTransaction,
	getCancelledRequest
};
